import * as React from "react";
import {Link} from "react-router-dom";
import NotificationModal from "../modals/NotificationModal";

interface IProps {
    to: string;
    primary?: boolean;
    primaryNoArrow?: boolean;
    id?: string;
    className?: string;
    disabled?: boolean;
    alertMessage?: string;
    routeState? : any;
}

interface IState {
    showAlert: boolean
}

export class ButtonLink extends React.Component<React.PropsWithChildren<IProps>, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            showAlert: false
        };
    }

    public render() {
        let btnTypeClassName: string;
        if (this.props.disabled) {
            btnTypeClassName = "btn-primary btn-gray";
        } else if (this.props.primary) {
            btnTypeClassName = "btn-primary btn-next";
        } else if (this.props.primaryNoArrow) {
            btnTypeClassName = "btn-primary btn-add";
        } else {
            btnTypeClassName = "btn-white";
        }

        return (
            <>
                <Link to={this.props.to}
                      state={this.props.routeState}
                      id={this.props.id}
                      className={`buttonLink ${this.props.className || ""}`}
                      onClick={this.handleClick}>
                    <button type="button"
                            disabled={this.props.disabled}
                            className={`btn ${btnTypeClassName} plugin`}>
                        {this.props.children}
                    </button>
                </Link>

                {this.props.alertMessage &&
                <NotificationModal show={this.state.showAlert} hide={this.hideAlert}>
                    {this.props.alertMessage}
                </NotificationModal>}
            </>
        );
    }

    private readonly handleClick = (event: any): void => {
        if (this.props.disabled) {
            event.preventDefault();
            this.setState({showAlert: true});
        }
    };

    private readonly hideAlert = () => {
        this.setState({showAlert: false});
    }
}

